import React, { useState } from 'react';
import MainCalculatorsList from '../MainCalculators';
import SharedHelmet from '../Helmet';
import RelatedLinks from '../RelatedLinks';
import { FirstAds, SecondAds,MobileUnderCalAds } from "../../Ads";
const TITLE = 'Convert University GPA to German Grading System';
const DESCRIPTION = "Easily and accurately convert your university GPA to the German grading system. Learn how to convert bachelor's and master's GPA to the German system using this helpful tool.";
const KEYWORDS = "Convert university GPA, convert to German grading system, bachelor's GPA, master's GPA, university GPA, German grading system";
const OG_URL = 'https://do-calculate.com/calculator/ar/gradetogerman';
function GradeToGerman() {
  const [originalValue, setOriginalValue] = useState('');
  const [convertedValue, setConvertedValue] = useState('');
  const [conversionType, setConversionType] = useState('grade');
  const [showResult, setShowResult] = useState(false);
  const [error, setError] = useState(null);
  const calculateGrade = (value) => {
    if (conversionType === 'grade') {
      const grade = parseFloat(value);
      if (!isNaN(grade) && grade >= 0 && grade <= 100) {
        return (1 + 3 * (4 - (grade / 25)) / 3).toFixed(2);
      }
    } else if (conversionType === 'gpa') {
      const gpa = parseFloat(value);
      if (!isNaN(gpa) && gpa >= 0 && gpa <= 4) {
        return (1 + 3 * (4 - gpa) / 3).toFixed(2);
      }
    }
    return 'Invalid input';
  };
  const getGradeTerm = (value) => {
    const grade = parseFloat(value);
    if (grade >= 1.0 && grade <= 1.5) {
      return 'Excellent';
    } else if (grade >= 1.6 && grade <= 2.5) {
      return 'Very Good';
    } else if (grade >= 2.6 && grade <= 3.5) {
      return 'Good';
    } else if (grade >= 3.6 && grade <= 4.0) {
      return 'Acceptable';
    } else if (grade >= 4.1 && grade <= 5.0) {
      return 'Fail';
    } else {
      return 'Invalid input';
    }
  };
  const handleCalculateClick = () => {
    const converted = calculateGrade(originalValue);
    setConvertedValue(converted);
    setShowResult(true);
    setError(null);
  };
  const handleConversionTypeChange = (newConversionType) => {
    setConversionType(newConversionType);
    setOriginalValue('');
    setConvertedValue('');
    setShowResult(false);
    setError(null);
  };
  return (
    <div>
      <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div className="bg-success text-white text-center" style={{ height: '40px' }}>
            <h1 style={{ fontSize: '17px' }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Easily <strong>convert your university GPA</strong> (whether it’s a percentage or cumulative) to the <strong>German grading system</strong> with precision using our advanced <strong>GPA conversion tool</strong>. This <strong>GPA calculator</strong> is designed to assist you in <strong>converting bachelor's and master's GPA to the German system</strong> accurately. Whether you're transitioning to study in Germany, applying for international programs, or need to <strong>convert your GPA for academic or professional purposes</strong>, our tool provides quick and reliable results. Understand the nuances of the <strong>German university grading system</strong> and utilize our <strong>GPA conversion tool</strong> to ensure your academic performance aligns with German standards. This essential <strong>GPA calculator</strong> helps you seamlessly adapt to the German educational framework with confidence.
                </p>
              </div>
              <br />
            </div>
            <hr />
             <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: '16px' }}>Convert University GPA to German Grading System</h2>
                </div>
                <hr />
                <div className="form-group">
                  <b><label>GPA Type:</label></b>
                  <div>
                    <input
                      type="radio"
                      id="gradeConversion"
                      name="conversionType"
                      value="grade"
                      checked={conversionType === 'grade'}
                      onChange={() => handleConversionTypeChange('grade')}
                      className="form-check-input"
                      style={{ marginLeft: '4px' }}
                    />
                    <label htmlFor="gradeConversion" className="form-check-label">Percentage (100)</label>
                  </div>
                  <div>
                    <input
                      type="radio"
                      id="gpaConversion"
                      name="conversionType"
                      value="gpa"
                      checked={conversionType === 'gpa'}
                      onChange={() => handleConversionTypeChange('gpa')}
                      className="form-check-input"
                      style={{ marginLeft: '4px' }}
                    />
                    <label htmlFor="gpaConversion" className="form-check-label">Cumulative (4.00)</label>
                  </div>
                </div>
                <br />
                <div>
                  <div className="form-group d-flex align-items-center">
                    <b><label htmlFor='originalValue'>{conversionType === 'grade' ? 'Percentage GPA:' : 'Cumulative GPA:'}</label></b>
                    <input
                      type="text"
                      value={originalValue}
                      id='originalValue'
                      onChange={(e) => setOriginalValue(e.target.value)}
                      className='form-control'
                      style={{ width: '200px', marginRight: '4px' }}
                    />
                  </div>
                  <div>
                    <br />
                  </div>
                </div>
                <button className="btn btn-success mt-3"
                  onClick={handleCalculateClick}
                >
                  Calculate                </button>
                <br />
              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-sm-12 col-md-7">
                {error && <div className="alert alert-warning"><b><u>Error:</u></b> {error}</div>}
                {showResult &&  (
                  <div style={{ fontSize: '15px' }} className="bg-light bg-gradient text-dark">
                    <div className="p-3 bg-success bg-gradient text-white">
                      <strong>Result:</strong>
                    </div>
                    <b>
                      {conversionType === 'grade'
                        ? `Percentage GPA in the German system: ${convertedValue} (${getGradeTerm(convertedValue)})`
                        : `Cumulative GPA in the German system: ${convertedValue} (${getGradeTerm(convertedValue)})`}
                    </b>
                  </div>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList CalculatorsTypeId={600}></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: 'auto' }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">{TITLE}</div>
              <div className="info-section-body">
                <div>
                  <u><h2 style={{ fontSize: '16px' }}>German University Grading System</h2></u>
                  <p>
                    In Germany, grades are classified on a scale from 1.0 to 5.0, where 1.0 is the best and 5.0 is the worst. The grades can be divided as follows:
                  </p>
                  <table >
                    <thead>
                      <tr className='bmi-header'>
                        <th>German Grade</th>
                        <th>Equivalent English Terms</th>
                        <th>Equivalent Percentage</th>
                        <th>Cumulative GPA (5-point scale)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1.0 – 1.5</td>
                        <td>Excellent</td>
                        <td>90-100%</td>
                        <td>5</td>
                      </tr>
                      <tr>
                        <td>1.6 – 2.5</td>
                        <td>Very Good</td>
                        <td>80-89%</td>
                        <td>4</td>
                      </tr>
                      <tr>
                        <td>2.6 – 3.5</td>
                        <td>Good</td>
                        <td>65-79%</td>
                        <td>3</td>
                      </tr>
                      <tr>
                        <td>3.6 – 4.0</td>
                        <td>Acceptable</td>
                        <td>50-64%</td>
                        <td>2</td>
                      </tr>
                      <tr>
                        <td>4.1 – 5.0</td>
                        <td>Fail</td>
                        <td>0-49%</td>
                        <td>1</td>
                      </tr>
                    </tbody>
                  </table>
                  <p>
                    This information helps in understanding how to convert grades to the German system and knowing their equivalents in English and percentage terms.
                  </p>
                  <b className='text-primary'>
                    <span>Example: </span>
                    If you have a cumulative GPA of 3.0 on a 4.0 scale, you can convert it to the German system using the tool above and get the equivalent result.
                  </b>
                  <p>
                    This tool is very useful for international students who wish to continue their studies in Germany or apply for jobs that require a specific academic GPA.
                  </p>
                  <div>
                    <p>
                      Germany is one of the leading countries in scientific advancement, with prestigious universities that attract students from all over the world, including the Arab countries.
                    </p>
                    <p className='alert alert-info'>
                      Germany has 15 universities among the top 200 in the world. Additionally, the academic system in German universities is known for its scientific rigor and modern curriculum. Another reason is the lower tuition costs compared to other European countries, the UK, and the United States.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default GradeToGerman;
